import React from 'react';
import PropTypes from 'prop-types';
import { Marker, DefaultSVG } from '@geo/react-grabmaps-gl';
import { REQUIRED_OFFSET } from '../../../constants/marker';

// TODO:: Learn how to test mapbox. Because testing library unable to test it, and this test is useless - @wesley.loh
const PickUpMarker = ({ coordinates }) => (
  <Marker
    coordinates={coordinates}
    offset={REQUIRED_OFFSET}
    style={{
      position: 'absolute',
      top: 0,
      left: 0,
      willChange: 'transform',
    }}
  >
    <DefaultSVG.PickUp />
  </Marker>
);

PickUpMarker.propTypes = {
  coordinates: PropTypes.arrayOf(PropTypes.number).isRequired,
};

export default PickUpMarker;
